// extracted by mini-css-extract-plugin
export default {"request_history":"RequestHistory_request_history__0GMLL","header":"RequestHistory_header__f+lgz","new_request":"RequestHistory_new_request__Bz0rT"};